module.exports = __webpack_public_path__ + "efb47b788a714e9c26a38a8498bfb881.mp4";